module.exports = __webpack_public_path__ + "static/cornerston-c9461bda19337b436ce1df221b2929d6.svg";